<template>
  <div
    class="max-w-md bg-white dark:bg-stone-800 rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg flex flex-col">
    <div class="px-6 pt-6 pb-2 flex-grow">
      <h3 class="text-2xl font-bold text-primary-600 dark:text-primary-400 mb-4">
        Trusted by Thousands
      </h3>
      <div class="text-stone-700 dark:text-stone-300">
        <p class="mb-4">
          <strong>Spin the Names</strong> has become the go-to random selector for classrooms, events, and businesses
          worldwide. Here's what our users say:
        </p>
        <blockquote class="pl-4 border-l-4 border-primary-300 italic mb-4">
          "My students get so excited when it's time to use the wheel! It's transformed our classroom participation
          completely."
          <footer class="not-italic text-stone-500 dark:text-stone-400 mt-1">— Sarah K., 4th Grade Teacher</footer>
        </blockquote>
        <blockquote class="pl-4 border-l-4 border-primary-300 italic mb-4">
          "We use Spin the Names for our monthly customer giveaways. The visual element makes it so much more engaging
          than just drawing a name from a hat."
          <footer class="not-italic text-stone-500 dark:text-stone-400 mt-1">— Marcus T., Marketing Director</footer>
        </blockquote>
        <p>
          Join the thousands of teachers, businesses, and organizations who trust our wheel for fair, exciting random
          selection!
        </p>
      </div>
    </div>
    <div class="h-1 bg-gradient-to-r from-primary-400 to-primary-300 flex-none"></div>
  </div>
</template>
